export default "__VITE_ASSET__CxoXjGcp__"